/**
 * @pageName BookingsStaffMemberForm
 * @slotType dashboard plugin
 */
export type EditStaffProfileBannerParams = {
  /* Staff Resource ID.*/ staffResourceId: string;
  /* Staff ID.*/ staffId: string;
};
/**
 * @pageName BookingsStaffMemberForm
 * @slotType dashboard menu plugin
 */
export type EditStaffProfileMainMoreActionsMenuParams = {
  /* Staff Resource ID.*/ staffResourceId: string;
  /* Staff ID.*/ staffId: string;
};
/**
 * @pageName BookingsStaffMemberForm
 * @slotType dashboard plugin
 */
export type StaffSettingsWidgetProps = {
  staffResourceId?: string;
  staffMemberId?: string;
  staffWixUserId?: string;
  staffName?: string;
  scheduleId?: string;
  staffEmail?: string;
  onBookingPermissionsRequest: () => void;
};
